import { FragmentParagraphStatFragment } from '@/utils/drupal-api/__generated__/graphql';
import clsx from 'clsx';

export type StatProps = {
  data: FragmentParagraphStatFragment;
  className?: string;
  isInverted?: boolean;
  id?: string;
};

export const Stat: React.FC<StatProps> = ({
  data,
  className,
  isInverted,
  id,
}) => {
  return (
    <section className={clsx(className, 'flex flex-col items-center')} id={id}>
      <div
        className={clsx(
          'flex items-center text-3xl',
          isInverted ? 'text-primary-contrastText' : 'text-primary-main'
        )}
      >
        {data.prefix}{' '}
        <span
          className={clsx(
            'text-5xl md:text-6xl lg:text-8xl',
            isInverted ? 'text-primary-contrastText' : 'text-primary-main'
          )}
        >
          {data.number}
        </span>{' '}
        {data.suffix}
      </div>
      {data.header && (
        <div
          className={clsx('caps-lg', isInverted ? 'text-white' : 'text-gray-9')}
        >
          {data.header}
        </div>
      )}
      {data.subHeader && (
        <div
          className={clsx('caps-md', isInverted ? 'text-white' : 'text-gray-9')}
        >
          {data.subHeader}
        </div>
      )}
    </section>
  );
};
